import { LoginUrls } from './urls';
import { OktaAuth } from '@okta/okta-auth-js';
import { getOktaClientId, getOktaIssuer } from './utils/environments';

const redirectUri = LoginUrls.getRedirectUriForOkta();
let instance: OktaAuth;

const getOktaProvider = () => {
  if (instance) {
    return instance;
  }
  instance = new OktaAuth({
    issuer: getOktaIssuer(),
    clientId: getOktaClientId(),
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    scopes: ['openid', 'email', 'signal', 'plume'],
    responseType: 'id_token',
    tokenManager: {
      autoRenew: true,
    },
  });
  return instance;
};

export default getOktaProvider;
